import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Spin } from "antd";
import { AuthProvider } from "./auth/AuthContext";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import { AppLayout } from "./layout/AppLayout";
import { LoginPage } from "./pages/LoginPage";
import { NotFoundPage } from "./pages/NotFoundPage";

// Route-level code splitting: each page's JS only downloads when someone
// actually navigates there, instead of all of it shipping in one bundle up
// front. Matters more than usual here since a lot of this app's users will
// be on phones/tablets over a pantry's WiFi, not a fast desktop connection -
// and most roles (STAFF especially) never touch the Admin pages at all.
const ClientSearchPage = lazy(() => import("./pages/clients/ClientSearchPage").then((m) => ({ default: m.ClientSearchPage })));
const ClientDetailPage = lazy(() => import("./pages/clients/ClientDetailPage").then((m) => ({ default: m.ClientDetailPage })));
const TodayPage = lazy(() => import("./pages/clients/TodayPage").then((m) => ({ default: m.TodayPage })));
const DonationsPage = lazy(() => import("./pages/donations/DonationsPage").then((m) => ({ default: m.DonationsPage })));
const ResourcesPage = lazy(() => import("./pages/resources/ResourcesPage").then((m) => ({ default: m.ResourcesPage })));
const FoodBanksPage = lazy(() => import("./pages/admin/FoodBanksPage").then((m) => ({ default: m.FoodBanksPage })));
const GroupsPage = lazy(() => import("./pages/admin/GroupsPage").then((m) => ({ default: m.GroupsPage })));
const GoLivePage = lazy(() => import("./pages/admin/GoLivePage").then((m) => ({ default: m.GoLivePage })));
const UsersPage = lazy(() => import("./pages/admin/UsersPage").then((m) => ({ default: m.UsersPage })));
const ReportsPage = lazy(() => import("./pages/reports/ReportsPage").then((m) => ({ default: m.ReportsPage })));
const SupportPage = lazy(() => import("./pages/SupportPage").then((m) => ({ default: m.SupportPage })));

function PageFallback() {
  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: 120 }}>
      <Spin size="large" />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Suspense fallback={<PageFallback />}>
          <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route element={<ProtectedRoute />}>
              <Route element={<AppLayout />}>
                <Route index element={<Navigate to="/clients" replace />} />
                <Route path="/clients" element={<ClientSearchPage />} />
                <Route path="/clients/:id" element={<ClientDetailPage />} />
                <Route path="/today" element={<TodayPage />} />
                <Route path="/donations" element={<DonationsPage />} />
                <Route path="/resources" element={<ResourcesPage />} />
                <Route path="/reports" element={<ReportsPage />} />
                <Route path="/support" element={<SupportPage />} />

                <Route element={<ProtectedRoute minRole="GROUP_ADMIN" />}>
                  <Route path="/admin/groups" element={<GroupsPage />} />
                  <Route path="/admin/users" element={<UsersPage />} />
                </Route>

                <Route element={<ProtectedRoute minRole="SUPER_ADMIN" />}>
                  <Route path="/admin/food-banks" element={<FoodBanksPage />} />
                  <Route path="/admin/go-live" element={<GoLivePage />} />
                </Route>

                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Route>
          </Routes>
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  );
}
